module.exports = __webpack_public_path__ + "img/corporateCulture5.5c512f1a.png";